import { createContext } from 'react';

const UserContext = createContext({ username: '', isLoggedIn: false });

export default UserContext;